module.exports = __webpack_public_path__ + "static/media/upcomingReservation.67810840.png";